import { render, staticRenderFns } from "./QuotationDocumentCafezal.vue?vue&type=template&id=5c36aefc"
import script from "./QuotationDocumentCafezal.vue?vue&type=script&lang=js"
export * from "./QuotationDocumentCafezal.vue?vue&type=script&lang=js"
import style0 from "./QuotationDocumentCafezal.vue?vue&type=style&index=0&id=5c36aefc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports